<template>
    <xl-form class="config-form" :model="formData" :key="forceKey" ref="configFormRef">
        <div v-for="(config) in optionsList" :key="config.id || config.preCode">
            <div v-if="config.paramApp ===1" style="display:none">{{formData[config.preCode]}}</div>
            <xl-form-item
                class="design-preference-config-item"
                :class="active === config.preCode ? 'design-preference-config-item-active':'' "
                v-else-if="preferItemShowMap[config.preCode] ? preferItemShowMap[config.preCode]?.showValue.includes(formData[preferItemShowMap[config.preCode]?.showKey]) : true"
                :prop="config.preCode"
                :label="config.preName"
                @mousedown="() => onFormItemMouseDown(config)"
            >
                <div v-if="config.preType === 'number'">
                    <!-- <xl-input v-if="config.preCode === 'DSD_colorNumber'" class="input-width" v-model="formData[config.preCode]" @mousedown="onIptMouseDown(config)" :placeholder="$t('design.preference.inputPlaceholder') || '请输入内容'">
                    </xl-input> -->
                    <ipt-number
                        v-model="formData[config.preCode]"
                        :controls="true"
                        :suffix="config.preUnit"
                        :min="config.preMin"
                        :max="config.preMax"
                        :step="config.preStep"
                        :preValue="config.preValue"
                        @mousedown="onIptMouseDown(config)"
                    ></ipt-number>
                </div>
                <config-select
                    v-else-if="config.preType === 'option'"
                    v-model="formData[config.preCode]"
                    :options="config.preOptions"
                    @change="(val) => onSelectChange(val, config)"
                    @mousedown="onSelectDown(config)"
                >
                </config-select>
            </xl-form-item>
        </div>
    </xl-form>
</template>

<script setup>
// 配置表单
import { ref, watch, defineExpose, defineProps, defineEmits, computed, onMounted } from 'vue';
import {
  XlForm, 
  XlFormItem,
  XlSelect,
  XlMessage,
  XlInput
} from '@shining3d/ui-components';
import { onClickOutside } from '@vueuse/core';
import IptNumber from './iptNumber.vue';
import configSelect from './configSelect.vue';
import { preferItemShowMap } from '../../../common/enum.js';
import { useLang } from "@shining3d/common-module/utils/lang.js";

const { $t } = useLang("@shining3d/xl-design-order");
const emits = defineEmits(['itemMouseDown'])

const props = defineProps({
    configList: {
        type: Object,
        default: () => []
    }
});

const formData = ref({});

const optionsList = computed(() => {
    return props.configList.map(item => {
        // uniqueKey 作为 表单 和 展示图片的对应映射关系
        const uniqueKey = item.preCode?.split('_')?.slice(-1)[0];
        let preOptions = [];
        if( item?.preOptions?.length ){
            preOptions = item.preOptions.map((item) => ({
                label: item?.optionValue,
                value: item?.optionCode
            }))
        }
        return {
            ...item,
            preOptions,
            uniqueKey
        }
    })
});

watch(() => optionsList.value, ( val ) => {
    formData.value = {};
    val.forEach(( item ) => {
        // 初始化默认值
        let value = item.preValue;
        if (item.preType === 'number' && item.preValue === '') {
            value = undefined;
        }
        formData.value[item.preCode] = value;
    });
}, { immediate: true, deep: true });

// 点击输入框的时候，取的是输入框的配置 uniqueKey
const onIptMouseDown = ( config ) => {
    emits('itemMouseDown', { key: config.uniqueKey })
};

// 点击下拉框的时候，取的下拉框选项的具体值
const onSelectDown = ( config ) => {
    // 判断是否有值
    emits('itemMouseDown', { key: formData.value[config.preCode],  preCode: config.preCode})
};

// 下拉选择值变化 - 传递 option value的值
const onSelectChange = ( value, config ) => {
    emits('itemMouseDown', { key: value, preCode: config.preCode })
};

const onFormItemMouseDown = ( config ) => {
    active.value = config.preCode;
    if ( config.preType === 'number' ) {
        onIptMouseDown( config );
    } else if ( config.preType === 'option' ){
        onSelectDown( config );
    }
};

const getValue = () => {
    const obj = {};
    const originConfigMap = {};
    props.configList.forEach(item => {
        originConfigMap[item.preCode] = item;
    })
    Object.keys(formData.value).forEach(key => {
        if (preferItemShowMap[key] && originConfigMap[key].paramApp !== 1) {
            // 有联动关系的表格项，只有展示的时候才会展示
            if (preferItemShowMap[key]?.showValue.includes(formData.value[preferItemShowMap[key]?.showKey])) {
                obj[key] = formData.value[key];
            }
        } else {
            obj[key] = formData.value[key];
        }
    });
    return obj;
};

// 重置为默认值
const getDefaultValue = () => {
    optionsList.value.forEach((item) => {
        formData.value[item.preCode] = item.preValue;
    })
}

const forceKey = ref(false);
const forceUpdate = () => {
    forceKey.value = !forceKey.value;
};

const configFormRef = ref(null);
const active = ref('');
onClickOutside(configFormRef, () => {
    active.value = '';
});


defineExpose({ formData, getValue, getDefaultValue, forceUpdate });
</script>

<style lang="scss" scoped>
.config-form {
    font-family: 'Alibaba PuHuiTi 2.0';
    cursor: pointer;
    :deep(.xl-select) {
        width: 204px;
    }
    :deep(.el-form-item__label) {
        width: 166px;
        display: flex;
        box-sizing: border-box;
        text-align: left;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        color: #42526E;
        cursor: pointer;
    }
    :deep(.el-form-item){
        margin-bottom: 12px !important;
    }
    .input-width{
        width: 204px;
    }
    :deep(.design-preference-config-item-active) {
        .el-input__inner {
            box-shadow: 0 0 0 2px var(--el-input-focus-border-color, var(--el-color-primary)) inset !important;
        }
    }
    :deep(.xl-select li.el-select-dropdown__item) {
        padding-right: 6px;
    }
}
</style>